module.exports = __webpack_public_path__ + "static/media/GrundfosSerieCR.460fa0ac.jpg";